module.exports = __webpack_public_path__ + "img/plan3_book06.45811698.png";